import { Component, Input, HostListener, OnInit, OnDestroy } from '@angular/core';
import { QueryService } from '../comun/services/query.service';
import { Muro } from '../comun/models/muro.model';
import { FuncionesService } from '../comun/services/funciones.service';
import { MuroService } from '../comun/services/muro.service';
import { Subject, takeUntil } from 'rxjs';
import { Title } from '@angular/platform-browser';
// Para cargar el perfil del usuario conectado
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { UsuarioPerfil } from '../comun/models/misdatos.model';
import { MisdatosService } from '../comun/services/misdatos.service';
import { PerfilService } from '../comun/services/perfil.service';
import { Valores } from '../comun/models/valores.model';
import { MuroFiltrosService } from '../comun/services/muro-filtros.service';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-muros',
  templateUrl: './muros.component.html',
  styleUrl: './muros.component.css'
})
export class MurosComponent implements OnInit, OnDestroy {
  @Input() userid: Number = 0;
  @Input() tipo: string = 'RS';
  @Input('tipo_id') tipoId: number = 0;
  @Input() titulo: string = '';
  @Input() subtitulo: string = '';
  private misdatosSub!: Subscription;
  misdatos: any = {};  
  private perfilSub!: Subscription;
  perfil: any = {};
  private muroFiltrosSub!: Subscription;
  muroFiltros: any = {};
  muros: Muro[] = [];
  ordenPublicaciones: 'recientes' | 'actividad' = 'recientes';

  cambiarOrden(orden: 'recientes' | 'actividad'): void {
    if (this.ordenPublicaciones === orden) return;
    this.ordenPublicaciones = orden;
    this.getPublicaciones(true, false);
  }

  // Orden provisional de los registros cargados. La paginación global debe
  // realizarse con el mismo criterio en el backend (parámetro orden).
  ordenarMuros(): void {
    if (this.ordenPublicaciones !== 'actividad') return;
    const fecha = (m: Muro): number => {
      const x: any = m;
      const valor = x.rs_ultima_actividad || x.ultima_actividad || x.rs_ultimo_comentario || x.rs_fechahora || '';
      const ms = Date.parse(String(valor).replace(' ', 'T'));
      return Number.isFinite(ms) ? ms : 0;
    };
    this.muros = [...this.muros].sort((a, b) => fecha(b) - fecha(a) || Number(b.rs_id) - Number(a.rs_id));
  }

  comentarioPublicado(muro: Muro): void {
    (muro as any).rs_ultima_actividad = new Date().toISOString();
    this.ordenarMuros();
  }

  paseosEstado: 'todos' | 'proximos' | 'finalizados' = 'todos';
  cambiarEstadoPaseos(estado: 'todos' | 'proximos' | 'finalizados'): void {
    if (this.paseosEstado === estado) return;
    this.paseosEstado = estado;
    this.getPublicaciones(true, false);
  }
  // Publicar solo en el muro general (userid = 0) o en el perfil propio.
  // Nunca permitir el editor de nuevas publicaciones en un perfil ajeno.
  get puedePublicar(): boolean {
    const conectado = Number(this.misdatos?.ID);
    const visitado = Number(this.userid);
    return this.busy === 0 && conectado > 0 && Number.isFinite(visitado) &&
      (visitado === 0 || visitado === conectado);
  }

  muro: Muro | null = null;
  //loading: boolean = false;
  finished: boolean = false;
  busy: number = 0;
  //page: number = 1;
  private destroy$ = new Subject<void>();

  constructor(public query: QueryService, 
              private funciones: FuncionesService, 
              public muroService: MuroService, 
              private titleService: Title,
              private misdatosService: MisdatosService,
              private perfilService: PerfilService,
              private muroFiltrosService: MuroFiltrosService) { }

  ngOnInit() {
    this.titleService.setTitle('iGuau Muros');
    // Asociar la tabla muros al servicio
    this.muroService.muro$
      .pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        this.muros = data;
        this.ordenarMuros();
      });
    this.getMisDatos();
    this.muro = this.funciones.initMuro(this.muro as Muro);
    this.muro.rs_tipo = this.tipo;
    this.muro.rs_tipo_id = this.tipoId;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    // Es buena práctica desuscribirse para evitar fugas de memoria
    this.misdatosSub?.unsubscribe();
    this.perfilSub?.unsubscribe();
    this.muroFiltrosSub?.unsubscribe();
  }

  trackById(index: number, item: Muro) {
    return item.rs_id;
  }

  getMisDatos() {
    ++this.busy;
    let primeraEmision = true;
    // Los cambios de misdatos$ también llegan después de guardar el perfil.
    // El indicador de carga y las suscripciones secundarias se inicializan UNA vez.
    this.misdatosSub = this.misdatosService.misdatos$
      .pipe(filter((misdatos): misdatos is UsuarioPerfil => misdatos !== null))
      .subscribe((misdatos: UsuarioPerfil) => {
        this.misdatos = misdatos;
        if (Number(this.userid) === Number(misdatos.ID) && !this.perfil?.ID) {
          this.perfil = misdatos;
        }
        if (primeraEmision) {
          primeraEmision = false;
          --this.busy;
          this.getPerfil();
          this.getMuroFiltros();
        }
      });
  }

  getPerfil() {
    //++this.busy;
    // 1. Escuchamos el observable
    this.perfilSub = this.perfilService.perfil$
      .subscribe((perfil: UsuarioPerfil | null) => {

        // 2. CONTROL: Si no existe el perfil (es null)
        if (!perfil) {
          // En un perfil ajeno nunca usar al usuario conectado como sustituto.
          this.perfil = Number(this.userid) === Number(this.misdatos?.ID)
            ? this.misdatos : {};
          return;
        }

        // Ignorar emisiones antiguas o correspondientes a otro perfil.
        if (Number(this.userid) > 0 && Number(perfil.ID) !== Number(this.userid)) {
          this.perfil = {};
          return;
        }
        this.perfil = perfil;
        //--this.busy;
      });
  }

  getMuroFiltros() {
    this.muroFiltrosSub = this.muroFiltrosService.valores$
      .pipe(
        tap((valores: Valores[]) => {
          // Este bloque se ejecuta CADA VEZ que el BehaviorSubject/Observable emite
          // Aquí puedes meter lógica extra, disparar otra función, etc.
          //console.log('MuroFiltros actualizados:', valores);
          //this.muroFiltros = valores;
          //this.muroService.resetPaginacion();
          //this.getPublicaciones(true, false);
        })
      )
      .subscribe((valores: Valores[]) => {
        if (!valores) return;
        this.muroFiltros = valores;
        this.muroService.resetPaginacion();
        this.getPublicaciones(true, false);
      });
  }

  getPublicaciones(refresh: boolean = false, loadmore: boolean = false) {
    //if (!this.perfil.rol_social)
    //  return;
    //this.loading = true;
    const tipo_publicaciones = this.generarStringParaSelect();
    const estado = this.muroService.estadoPaginacion;
    if (!refresh && (!estado.hasMore || estado.loading)) return;
    if (refresh) {
      this.muroService.resetPaginacion();
      this.muroService.limpiar();
      this.finished = false;
    }
    this.muroService.setLoading(true);
    this.query.query('muros', 'RED', { ID: this.userid, rs_id: 0, tipo: this.tipo, tipo_id: this.tipoId, tipo_publicacion: tipo_publicaciones, paseos_estado: this.paseosEstado, orden: this.ordenPublicaciones, page: this.muroService.page, limit: this.muroService.limit }).subscribe((resultado:any) => {
      if (!loadmore)
        this.muroService.setMuro(resultado);
      else
        this.muroService.appendMuro(resultado);
      /*if (resultado.length > 0) {
        this.muros.push(...resultado);
      }*/
      this.finished = true;
      //this.loading = false;
      this.muroService.setLoading(false);
    }, () => {
      this.finished = true;
      this.muroService.setLoading(false);
    });
  }

  generarStringParaSelect() {
    // 1. Control de seguridad: Si no es un array, devolvemos un string vacío
    if (!Array.isArray(this.muroFiltros)) {
      return ""; // Sin filtros: mostrar todas las categorías
    }

    // 2. Filtramos solo los que estén activos
    const filtrosActivos = this.muroFiltros.filter((tipo: any) => tipo.activo);

    // 3. Extraemos el va_id y le añadimos comillas simples
    const valoresConComillas = filtrosActivos.map((tipo: any) => `'${tipo.va_id}'`);

    // 4. Agregamos las comillas simples vacías al INICIO del array
    //valoresConComillas.unshift("''");

    // 5. Los unimos todos con una coma y un espacio
    const resultadoString = valoresConComillas.join(', ');

    // Resultado si '01' y '02' están activos: '', '01', '02'
    // Resultado si ninguno está activo: ''
    return resultadoString || "";
  }

  @HostListener('window:scroll', [])
  onScroll() {
    //if (this.loading || !this.finished) return;
    const pos = window.innerHeight + window.scrollY;
    const max = document.body.offsetHeight;

    if (pos >= max - 150) {
      this.getPublicaciones(false, true);
    }
  }

}
